import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/Reports.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import TopNav from "./TopNav";
import axios from "axios";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Reports extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            open: false,
            dialogHasConfirm: false,
            retry: false,
            error: false,
            error_text: "",
            dialogText: "",
            dialogTitle: "",
            dialogType: "NONE",
            loading: false,
            chosenTopNav:0,
            topNav:[
                {
                    name:"سفارشات",
                },
                {
                    name:"خدمات",
                },
                {
                    name:"پرداخت ها",
                },
                {
                    name:"آگهی ها",
                },
            ],
            ordersList:[],
            walletList:[],
        };
    }



    componentDidMount = () => {
        if(ls.get("report_type") != null)
            this.topNavClick(ls.get("report_type"));
        else
            this.topNavClick(0);
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        return (
            <div className="App ">
                <Loading loading={this.state.loading}/>
                {this.renderContent()}
            </div>
        );
    }

    renderContent(){
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );

        return (
            <div className="App-body bg-white">
                <TopNav name={"گزارشات"} productsList={this.state.buy_list} />

                <div className={"content contentCart"} style={{top:"45px",paddingTop:"0"}} >
                    {this.renderPages()}
                </div>
            </div>
        );
    }

    renderPages = ()=>{
        let dialogConfirm = "";
        if(this.state.dialogHasConfirm)
            dialogConfirm = (
                <Button onClick={this.handleConfirm} color="success" autoFocus>
                    تایید
                </Button>
            );

        return(
            <div>
                <div id={"reportsTopNav"}>
                    {this.state.topNav.map((data,index)=>{
                        return (<div className={(index === this.state.chosenTopNav)?"reportsTopNav active":"reportsTopNav"} onClick={(e)=>this.topNavClick(index)}>{data.name}</div>);
                    })}
                </div>
                <div id={"reportsBody"}>
                    {this.renderSwitch()}
                </div>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.dialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            بستن
                        </Button>
                        {dialogConfirm}
                    </DialogActions>
                </Dialog>
            </div>
        )

    };
    renderSwitch = ()=>{
        switch (this.state.chosenTopNav) {
            case (0) :
                return this.renderOrders();
            case (1) :
                return this.renderServices();
            case (2) :
                return this.renderPayments();
            case (3) :
                return this.renderNews();
        }
    };

    renderOrders = ()=>{
        return this.state.ordersList.map((order)=>{
            let status = "";
            switch (order.order_status) {
                case("-1"): status="عدم پرداخت";break;
                case("0"): status="درانتظار پرداخت";break;
                case("1"): status="در انتظار تایید مدیریت";break;
                case("2"): status="در حال آماده سازی";break;
                case("3"): status="آماده ارسال";break;
                case("4"): status="تحویل پیک داده شده";break;
                case("5"): status="تحویل مشتری داده شد";break;
                case("6"): status="لغو سفارش";break;
                case("10"): status="در انتظار تایید";break;
            }
            return (
                <div className={"orderItem"} onClick={()=>this.loadOrderDetails(order.id)}>
                    <div className={"orderItemRow"}>
                        <div className={"orderItemLabel"}>شماره سفارش</div>
                        <div className={"orderItemValue"}>{order.id}</div>
                    </div>
                    <div className={"orderItemRow"}>
                        <div className={"orderItemLabel"}>تاریخ</div>
                        <div className={"orderItemValue"}>{order.created_at}</div>
                    </div>
                    <div className={"orderItemRow"}>
                        <div className={"orderItemLabel"}>مبلغ کل</div>
                        <div className={"orderItemValue"}>{new Intl.NumberFormat("fa").format(order.price)} تومان</div>
                    </div>
                    <div className={"orderItemRow"}>
                        <div className={"orderItemLabel"}>وضعیت سفارش</div>
                        <div className={"orderItemValue"} style={{color:"#db286e"}}>{status}</div>
                    </div>
                    <hr style={{margin:"0 10px"}}/>
                    {order.stores_order_status.map((stores)=>{
                        return (
                            <div className={"orderItemRow"}>
                                <div className={"orderItemLabel center"} style={{color:"#db286e"}}>{stores.store_name}</div>
                                <div className={"orderItemValue center"}>{stores.order_status}</div>
                            </div>
                        );
                    })}
                </div>
            );
        })
    };
    renderPayments = ()=>{
        return this.state.walletList.map((walletHistory)=>{
            return (
                <div className={"WalletItem"} >
                    <div className={"paymentItemRow"}>
                        <div className={"paymentItemLabel"}>
                            <img className={"paymentIcon"} src={`${process.env.PUBLIC_URL}/assets/images/hnumber.png`}/>
                        </div>
                        <div className={"paymentItemValue"}>شماره تراکنش : {walletHistory.id}</div>
                    </div>

                    <div className={"paymentItemRow"}>
                        <div className={"paymentItemLabel"}>
                            <img className={"paymentIcon"} src={`${process.env.PUBLIC_URL}/assets/images/hvalue.png`}/>
                        </div>
                        <div className={"paymentItemValue"}>مقدار : {new Intl.NumberFormat("fa").format(walletHistory.value)} تومان</div>
                    </div>

                    <div className={"paymentItemRow"}>
                        <div className={"paymentItemLabel"}>
                            <img className={"paymentIcon"} src={`${process.env.PUBLIC_URL}/assets/images/hincrease.png`}/>
                        </div>
                        <div className={"paymentItemValue"}>{walletHistory.type}</div>
                    </div>

                    <div className={"paymentItemRow"}>
                        <div className={"paymentItemLabel"}>
                            <img className={"paymentIcon"} src={`${process.env.PUBLIC_URL}/assets/images/hdate.png`}/>
                        </div>
                        <div className={"paymentItemValue"}>{walletHistory.datetime}</div>
                    </div>

                    <div className={"paymentItemRow"}>
                        <div className={"paymentItemLabel"}>
                            <img className={"paymentIcon"} src={`${process.env.PUBLIC_URL}/assets/images/hvalue.png`}/>
                        </div>
                        <div className={"paymentItemValue"}>موجودی : {(walletHistory.remained_balance != null)?new Intl.NumberFormat("fa").format(walletHistory.remained_balance):"نامشخص"}</div>
                    </div>
                    <div className={"paymentStatus"}>وضعیت تراکنش: {(walletHistory.status == 1)?"موفق":"ناموفق"}</div>
                </div>
            );
        })
    };
    renderNews = ()=>{

    };
    renderServices = ()=>{

    };
    handleClose  = () => {
        this.setState({open:false})
    };
    topNavClick = (index) =>{
        this.setState({chosenTopNav:index});
        switch (index) {
            case (0) :
                return this.loadOrders();
            case (1) :
                return this.loadServices();
            case (2) :
                return this.loadPayments();
            case (3) :
                return this.loadNews();
        }
    };
    loadOrders = ()=>{
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.getLastOrders+"?token="+ls.get("token"))
            .then(res => {
                if(res.data.code == 200){
                    this.setState({
                        ordersList:res.data.order,
                        loading:false});
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false});
            });
    };
    loadPayments = ()=>{
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.history_wallet+"?token="+ls.get("token"))
            .then(res => {
                console.log("Report Payment : ",res.data);
                if(res.data.code == 200){
                    this.setState({
                        walletList:res.data.wallet.data,
                        loading:false});
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false});
            });
    };
    loadNews = ()=>{

    };
    loadServices = ()=>{

    };

    loadOrderDetails =(id)=>{
        this.props.history.push({
            pathname: '/order',
            state: {id:id}
        });

    }
}



export default Reports;
